import React from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../blogPosts";

export default function BlogList() {
  return (
    <section className="bg-white text-gray-900">
      <div className="container px-5 py-16 mx-auto max-w-5xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold title-font text-gray-900 mb-4">
            Insights
          </h1>
          <p className="text-base leading-relaxed lg:w-2/3 mx-auto text-gray-600">
            Notes from real engineering work: architecture, modernisation
            and the practical side of building software that lasts.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {blogPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="block bg-purple-50 border border-purple-100 rounded-xl p-8 hover:border-purple-300 transition-colors"
            >
              <p className="text-purple-600 text-xs uppercase tracking-widest font-semibold mb-3">
                {new Date(post.date).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </p>
              <h2 className="text-gray-900 text-xl title-font font-medium mb-3">
                {post.title}
              </h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                {post.excerpt}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {post.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-xs bg-white text-purple-600 border border-purple-200 rounded-full px-2 py-0.5"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
